<script lang="ts" setup>
import SectionAccount from './section-account.vue'
import MenuCategory from './menu-category.vue'
import ModalAddBankAccount from '~common/account/modal-add-bank-account.vue'
import { AccountTabs } from '~/constants/account'

const config = useRuntimeConfig()

const tabs = [
  [
    {
      link: AccountTabs.DEPOSIT,
      name: 'Nạp tiền',
      tab: 'deposit',
      component: defineAsyncComponent(async () => await import('~desktop/pages/account/deposit-section.vue'))
    },
    {
      link: `${AccountTabs.WITHDRAW}&type=ibanking`,
      name: 'Rút tiền',
      tab: 'withdraw',
      component: defineAsyncComponent(async () => await import('~desktop/pages/account/withdraw-section.vue'))
    },
    {
      link: AccountTabs.TRANSFER_MONEY,
      name: 'Chuyển ví',
      tab: 'transfer-money',
      component: defineAsyncComponent(async () => await import('~desktop/pages/account/transfer/transfer.vue'))
    }
  ].concat(config.public.IS_P2P_TRADING_ENABLED
    ? {
      link: AccountTabs.COIN12,
      name: 'Giao dịch Coin12',
      tab: 'coin12',
      component: defineAsyncComponent(async () => await import('~common/account/coin-12.vue'))
    }
    : []),
  [
    {
      link: AccountTabs.HISTORY_TRANSACTION,
      name: 'Lịch sử giao dịch',
      tab: 'history-transaction',
      component:
        defineAsyncComponent(async () => await import('~desktop/pages/account/history/transaction-section.vue'))
    },
    {
      link: AccountTabs.HISTORY_BETTING,
      name: 'Lịch sử cá cược',
      tab: 'history-betting',
      component: defineAsyncComponent(async () => await import('~desktop/pages/account/history/betting-section.vue'))
    }
  ],
  [
    {
      link: AccountTabs.INFORMATION,
      name: 'Thông tin cá nhân',
      tab: 'information',
      component: defineAsyncComponent(async () => await import('~desktop/pages/account/info-personal-form.vue'))
    },
    {
      link: AccountTabs.CHANGE_PASSWORD,
      name: 'Đổi mật khẩu',
      tab: 'change-password',
      component: defineAsyncComponent(async () => await import('~desktop/pages/account/info-password-form.vue'))
    },
    {
      link: AccountTabs.REFUND,
      name: 'Khuyến mãi',
      tab: 'refund',
      component: defineAsyncComponent(async () => await import('~/components/desktop/pages/account/info-refund.vue'))
    },
    {
      link: AccountTabs.USER_BANK,
      name: 'Ngân hàng chính chủ',
      tab: 'user-bank',
      component: defineAsyncComponent(async () => await import('~desktop/pages/account/information-bank.vue'))
    }
  ]
]

const route = useRoute()

const currentMenu = ref(tabs[0])
const currentTab = ref(currentMenu.value[0])

watch(
  () => route.query.tab,
  tab => {
    for (const menu of tabs) {
      for (const menuItem of menu) {
        if (menuItem.tab === tab) {
          currentMenu.value = menu
          currentTab.value = menuItem
          return
        }
      }
    }
  },
  { immediate: true }
)
</script>
<template>
  <ClientOnly>
    <div class="page-account">
      <div class="page-wrapper container">
        <div class="page-wrapper__left">
          <SectionAccount />
        </div>
        <div class="page-wrapper__right">
          <MenuCategory :menu="currentMenu" :currentTab="currentTab.tab" />
          <div v-if="currentTab?.component" class="page-wrapper__right--content">
            <component :is="currentTab.component" />
          </div>
        </div>
      </div>
      <ModalAddBankAccount />
    </div>
  </ClientOnly>
</template>
<style lang="scss" scoped>
@import '~scssAsset/desktop/pages/account/index.scss';
</style>
